export default "__VITE_ASSET__2E_ki2Mo__"